export default __webpack_public_path__ + "45e42f71a06f31fd1e39d97f1000e1df.svg";